export default __webpack_public_path__ + "static/media/ProfileDesktop.fe698351.png";